<template>
  <div class="details">

    <div class="page__header">
      <div class="page__title" v-if="this.$route.params.entity == 'customer'">{{ $t(`accountDetails.${"costumerTitle"}`)
      }} </div>
      <div class="page__title" v-if="this.$route.params.entity == 'lead'">LEAD {{
        $t(`accountDetails.${"costumerTitle"}`) }}</div>
      <div class="page__title" v-if="this.$route.params.entity == 'user'">{{ $t(`accountDetails.${"userTitle"}`) }}
      </div>
      <div class="page__right"
        v-if="(this.$route.params.entity === 'customer' || this.$route.params.entity === 'potential-customer') && this.customer && this.customer.customer_status && this.customer.customer_status.id == 1">

        <form class="search search--filter" @submit.prevent="keywordsSearch()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = !showSearchFilter"></div>
          <SearchFilter :searchType="'customer'" v-if="showSearchFilter" :filterToggler="$refs.filterToggler"
            :toggleSearchFilter="(state) => {
              showSearchFilter = state;
            }
              " />
        </form>



        <button v-if="!detailsLoading" class="button button--default button--animated"
          @click="$store.commit('setShowAddCustomerServicesModal', true)">
          <div class="button__icon"></div>
        </button>
        <button v-else class="button button--default button--animated">
          <Loading />
        </button>
      </div>

      <div class="page__right" v-else-if="this.$route.params.entity === 'lead'">
        <button v-if="!detailsLoading" class="button button--default button--animated"
          @click="$store.commit('setShowAddLeadModal', true)">
          <div class="button__icon"></div>
        </button>
        <button v-else class="button button--default button--animated">
          <Loading />
        </button>
      </div>

      <div class="page__right" v-if="this.$route.params.entity == 'user'">
        <form class="search" @submit.prevent="searchUsersForms()">
          <input class="search__search" :class="{ 'search--active': searchKeywordsUsers.length }" type="text"
            v-model="searchKeywordsUsers" />
        </form>
        <button v-if="$checkRolePermission('user_create')" class="users__button button button--default"
          @click="$store.commit('setShowAddUserModal', true)">
          {{ $t(`settings.user.${"addUserBtn"}`) }}
        </button>
      </div>
    </div>
    <div class="details__content">
      <div class="detail box box--default">
        <Loading v-if="detailsLoading" />
        <template
          v-else-if="($route.params.entity === 'customer' || $route.params.entity === 'potential-customer' || $route.params.entity === 'lead') ? (customer && customer.id) : (user && user.id)">
          <div class="detail__edit icon icon__edit" @click="
            $route.params.entity === 'lead'
              ? editLead(customer)
              : ($route.params.entity === 'customer' || $route.params.entity === 'potential-customer')
                ? editCustomer(customer.id)
                : editUser()
            "></div>
          <div class="detail__info">
            <div class="detail__avatar">
              <img v-if="photo" :src="photo" alt="" />
              <div class="detail__avatar-company-icon" v-else-if="memberType === statics.memberTypes.company">
                <img src="../assets/icons/default/Bold 2px-building.svg" alt="" />
              </div>
              <div v-else class="initials" :style="{ background: customer.color || '#7f8fa4' }">
                {{ parseInitials(customer.first_name, customer.last_name) }}
              </div>
            </div>

            <div class="detail__splitter"></div>

            <div class="detail__profile">
              <div v-if="
                $route.params.entity === 'customer' ||
                $route.params.entity === 'potential-customer' ||
                $route.params.entity === 'lead'
              " class="detail__name">
                <span v-if="memberType === statics.memberTypes.company">{{
                  customer.company_name
                }}</span>
                <span v-else-if="memberType === statics.memberTypes.private">{{
                  `${customer.first_name} ${customer.last_name}`
                }}</span>
              </div>
              <div v-else class="detail__name">
                {{ user.first_name }} {{ user.last_name }}
              </div>



              <template v-if="
                $route.params.entity === 'customer' ||
                $route.params.entity === 'potential-customer' ||
                $route.params.entity === 'lead'
              ">
                <div class="detail__emails" v-if="email.length">
                  <div class="detail__emails__wrapper">
                    <div class="detail__email__edit">
                      <div class="detail__email">
                        {{ email[0].email }}
                      </div>
                      <div class="email__edit__icon icon icon__edit" @click="
                        $route.params.entity === 'customer'
                          ? editEmail(customer.id, email[0].id)
                          : editEmail(customer.id, email[0].id)
                        "></div>
                    </div>
                    <div v-if="email[0].online_shipping" style="display: flex;">
                      <div class="icon icon__tick__color"></div>
                      <p class="detail__email">Onlineversand</p>
                    </div>
                  </div>

                  <div class="detail__email detail__email--secondary" :style="showDetails
                    ? { maxHeight: '1000px', marginTop: '10px', marginBottom: '10px' }
                    : { maxHeight: '0', margin: '0', }
                    ">
                    <div v-for="(email, index) in email" :key="`email${email.id}`">
                      <div v-if="index !== 0" class="detail__emails__wrapper">
                        <div class="detail__email__edit">
                          <p style="height: 22px;">{{ email.email }}</p>
                          <div class="email__edit__icon icon icon__edit" style="height: 22px;" @click="
                            $route.params.entity === 'customer'
                              ? editEmail(customer.id, email.id)
                              : editEmail(customer.id, email.id)
                            "></div>
                        </div>
                        <div v-if="email.online_shipping" style="display: flex;">
                          <div class="icon icon__tick__color"></div>
                          <p class="detail__email">Onlineversand</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="details__phones" v-if="phone.length">
                  <div class="detail__phone">
                    {{ phone[0].phone }}
                  </div>
                  <div class="detail__phone detail__phone--secondary" v-for="(phone, index) in phone"
                    :key="`phone${phone.id}`" :style="showDetails
                      ? { maxHeight: '16px' }
                      : { maxHeight: '0', margin: '0' }
                      ">
                    <span v-if="index !== 0">{{ phone.phone }}</span>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="detail__email">
                  {{ email }}
                </div>
                <div class="detail__phone">
                  {{ phone }}
                </div>
              </template>
            </div>

            <div class="detail__splitter"></div>

            <div class="det" @click="showDetails = !showDetails">
              <div class="det__header">
                <div class="det__title">
                  <span v-if="showDetails">Less details...</span>
                  <span v-else>More details...</span>
                </div>
                <div class="det__chevron" :class="{ 'det__chevron--more': showDetails }"></div>
              </div>
            </div>

            <div class="detail__splitter"></div>
            <div class="detail__about">
              <template v-if="memberType === statics.memberTypes.private">
                <div class="detail__label">{{ $t(`searchCustomerFields.${"birthday"}`) }}:</div>
                <div class="detail__detail">{{ birthday }}</div>
              </template>
              <template v-if="memberType === statics.memberTypes.company">
                <div class="detail__label">Ansprechspartner:</div>
                <div class="detail__detail">
                  <span>{{ comment }} </span>
                </div>
              </template>
              <div class="detail__label">Address:</div>
              <div class="detail__detail">
                <span>{{ street }} </span>
                <span>{{ number }}</span>
              </div>
              <div class="detail__label">Team:</div>
              <div class="detail__detail">
                <span>{{ teamName }} </span>
              </div>
              <div class="detail__label">Zip / City:</div>
              <div class="detail__detail">
                <span>{{ zip }}</span>
                <span> / </span>
                <span>{{ city }}</span>
              </div>
              <template v-if="memberType === statics.memberTypes.private">
                <div class="detail__label">Nationality:</div>
                <div class="detail__detail">
                  {{ country }}
                </div>
              </template>


              <template v-if="$route.params.entity === 'user'">
                <div class="detail__label">{{ $t(`searchCustomerFields.${"birthday"}`) }}:</div>
                <div class="detail__detail">
                  {{ birthday }}
                </div>
                <div class="detail__label">Finma Nr. :</div>
                <div class="detail__detail">
                  {{ finmaNr }}
                </div>
              </template>
            </div>

            <div class="detail__splitter"></div>
            <div class="detail__about" ref="details" :style="showDetails
              ? { maxHeight: `${detailsHeight()}px` }
              : { maxHeight: '0px' }
              ">
              <template>


                <div class="detail__label">Sachbearbeiter: </div>
                <div class="detail__detail">
                  {{ sachbearbeiter }}
                </div>
              </template>
              <div class="detail__label">Language:</div>
              <div class="detail__detail">{{ language }}</div>
              <div class="detail__label">Job:</div>
              <div class="detail__detail">{{ job }}</div>
              <div class="detail__label">Employer:</div>
              <div class="detail__detail">{{ employer }}</div>
              <div class="detail__label">AHV Nr.:</div>
              <div class="detail__detail">
                {{ ahvNr }}
              </div>
              <div class="detail__label">IBAN:</div>
              <div class="detail__detail">
                {{ iBan }}
              </div>
              <div class="detail__label">Bankname:</div>
              <div class="detail__detail">
                {{ bankName }}
              </div>
            </div>
          </div>

          <div class="detail__members user-teams" v-if="$route.params.entity === 'user' && teams && teams.length > 0">
            <div class="member user-team" v-for="(team, index) in teams" :key="team.id"
              :style="{ zIndex: `${98 - index}` }" @click.stop="showTeamDropdown = team.id">
              <div class="member__overlay"></div>
              <div class="member__icon">
                <span>
                  <img src="../assets/icons/default/team_icon_grey.svg">
                </span>

              </div>
              <div class="member__name" style="padding: 0;">
                <p>{{ team.name }}</p>
              </div>
              <div class="table icon icon__dots" @click.stop="showTeamDropdown = team.id">

                <MembersActionDropdown v-if="showTeamDropdown === team.id" @toggleDropdown="showTeamDropdown = null"
                  :isTax=true :onTaxes="function () { openTeamTaxes(team) }" />
              </div>
            </div>
          </div>

          <div class="detail__members" v-if="
            $route.params.entity === 'customer' ||
            $route.params.entity === 'potential-customer' ||
            $route.params.entity === 'lead'
          ">
            <div class="member" :class="[
              `member--${parseMemberGender(member.gender_id)}`,
              { 'member--active': customer && customer.id === member.id },
            ]" v-for="(member, index) in customerMembers" :key="member.id" :style="{ zIndex: `${98 - index}` }"
              @click="selectMember(member.id)">
              <div class="member__overlay"></div>

              <div class="member__icon" v-if="member.gender">
                <span v-if="member.gender.id == 1">
                  <img src="../assets/icons/default/male_user_icon.svg">
                </span>

                <span v-if="member.gender.id == 2">
                  <img src="../assets/icons/default/female_user_icon.svg">
                </span>
              </div>
              <div class="member__name" style="padding: 0;"> 
                <p>{{ parseCustomerMemberName(member) }}</p> 
              </div>
              <div v-if="member.parent_id" @click.stop="showActionsDropdown = member.id" class="table icon icon__dots">

                <MembersActionDropdown v-if="showActionsDropdown === member.id"
                  @toggleDropdown="showActionsDropdown = null"
                  :onEdit="function () { selectMember(member.id); editCustomer(member.id) }"
                  :onDelete="function () { deleteMember(member.id) }"
                  :onSeparate="function () { separateMember(member.id) }" :isTax=false />
              </div>
            </div>

            <button class="button button--default" @click="openAddMemberModal()">
              <div class="button__icon"></div>
              <div class="button__text">
                {{ $t(`accountDetails.${"details"}.${"addMemberButton"}`) }}
              </div>
            </button>
          </div>
          <button v-if="$route.params.entity === 'user'" type="button"
            class="button button--default detail__password-button"
            @click="$store.commit('setShowResetPasswordModal', true)">
            Reset Password
          </button>
        </template>
      </div>
      <div class="container">
        <div class="tabs">
          <template v-if="
            ($route.params.entity === 'customer' ||
              $route.params.entity === 'potential-customer') && customer
          ">
            <div v-if="$checkRolePermission('policy_access')" class="tab tab--policy" @click="changeTab(0)"
              :class="{ 'tab--active': activeTab === 0 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"policy"}`) }}</span>
            </div>

            <div class="tab tab--policy" @click="changeTab(9)" :class="{ 'tab--active': activeTab === 9 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"offers"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('pendency_access')" class="tab tab--pendencies" @click="changeTab(1)"
              :class="{ 'tab--active': activeTab === 1 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"pendencies"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('note_access')" class="tab tab--notes" @click="changeTab(2)"
              :class="{ 'tab--active': activeTab === 2 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"notes"}`) }}</span>
            </div>

            <div class="tab tab--mandate" :class="{ 'tab--active': activeTab === 3 }" @click="changeTab(3)">
              <span>{{ $t(`accountDetails.${"tabs"}.${"mandate"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('call_access')" class="tab tab--calls" @click="changeTab(4)"
              :class="{ 'tab--active': activeTab === 4 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"calls"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('potential_policy_access')" class="tab tab--policy" @click="changeTab(5)"
              :class="{ 'tab--active': activeTab === 5 }">
              <span>
                {{ $t(`accountDetails.${"tabs"}.${"potential"}`) }}
              </span>
            </div>

            <div v-if="$checkRolePermission('policy_invoice_access')" class="tab tab--payments" @click="changeTab(6)"
              :class="{ 'tab--active': activeTab === 6 }">
              <span>
                {{ $t(`accountDetails.${"tabs"}.${"payment"}`) }}
              </span>
            </div>

            <div v-if="$checkRolePermission('policy_accident_access')" class="tab tab--accidents" @click="changeTab(7)"
              :class="{ 'tab--active': activeTab === 7 }">
              <span>
                {{ $t(`accountDetails.${"tabs"}.${"accident"}`) }}
              </span>
            </div>

            <div class="tab tab--archives" :class="{ 'tab--active': activeTab === 8 }" @click="changeTab(8)">
              <span>{{ $t(`accountDetails.${"tabs"}.${"archives"}`) }}</span>
            </div>
          </template>

          <template v-else-if="$route.params.entity === 'lead'">
            <div v-if="$checkRolePermission('policy_access')" class="tab tab--policy"
              :class="{ 'tab--active': activeTab === 10 }">
              <span>Leads</span>
            </div>
          </template>

          <template v-else-if="$route.params.entity === 'user'">
            <div class="tab tab--policy" :class="{ 'tab--active': activeTab === 0 }" @click="changeTab(0)">

              <span>{{ $t(`accountDetails.${"tabs"}.${"notifications"}`) }}</span>
            </div>
            <div class="tab tab--policy" @click="changeTab(1); getUserAuthLog($route.params.id)"
              :class="{ 'tab--active': activeTab === 1 }">

              <span>{{ $t(`accountDetails.${"tabs"}.${"authLogs"}`) }}</span>
            </div>
          </template>
        </div>

        <div class="content">
          <template v-if="
            ($route.params.entity === 'customer' ||
              $route.params.entity === 'potential-customer') && customer
          ">
            <transition name="fade" mode="in-out">
              <PolicyTable v-if="activeTab === 0 && $checkRolePermission('policy_access')" :policies="policies"
                :terminations="terminations" :detailsLoading="detailsLoading"
                :expandedPolicyId="$route.params.subEntityType === 'policy' ? Number($route.params.subEntityId) : null"
                :class="{ content__top: activeTab === 0 }" />

              <PendenciesTable v-if="activeTab === 1 && $checkRolePermission('pendency_access')" :expandedPendencyId="$route.params.subEntityType === 'pendency'
                ? Number($route.params.subEntityId)
                : null
                " :class="{ content__top: activeTab === 1 }" />

              <NotesTable v-if="activeTab === 2 && $checkRolePermission('note_access')"
                :class="{ content__top: activeTab === 2 }" />

              <CallsTable v-if="activeTab === 4 && $checkRolePermission('call_access')"
                :class="{ content__top: activeTab === 4 }" />

              <PotentialPolicyTable v-if="activeTab === 5 && $checkRolePermission('potential_policy_access')"
                :potentialPolicies="potentialPolicies" :detailsLoading="detailsLoading"
                :class="{ content__top: activeTab === 5 }" />

              <Invoices v-if="activeTab === 6 && $checkRolePermission('policy_invoice_access')"
                :class="{ content__top: activeTab === 6 }" :detailsLoading="detailsLoading" :policies="policies" />

              <Accidents v-if="activeTab === 7 && $checkRolePermission('policy_accident_access')"
                :class="{ content__top: activeTab === 7 }" :detailsLoading="detailsLoading" :policies="policies" />

              <MandatesTable v-if="activeTab === 3" :class="{ content__top: activeTab === 3 }" />

              <OffersTable v-if="activeTab === 9" :class="{ content__top: activeTab === 9 }" />
            </transition>
          </template>

          <template v-if="
            $route.params.entity === 'lead'
          ">
            <transition name="fade" mode="in-out">
              <CustomerLeadsTable v-if="activeTab === 10" :class="{ content__top: activeTab === 10 }" />
            </transition>
          </template>

          <template v-else-if="$route.params.entity === 'user'">
            <transition name="fade" mode="in-out">
              <div v-if="activeTab === 0" class="notifications">
                <NoData v-if="!notifications.length" :type="'notifications'" />
                <template v-else>
                  <Notification v-for="notification in notifications" :key="notification.id"
                    :notification="notification" />
                </template>

              </div>
              <div v-if="activeTab === 1" class="logs">
                <template v-if="logsLoading">
                  <Loading />
                </template>
                <template v-else>
                  <NoData v-if="!userAuthLog.data.length" :type="'authLogs'" />
                  <template v-else>
                    <div class="auth-wrapper">
                      <div class="auth-row" v-for="auth in userAuthLog.data" :key="auth.id">
                        <div class="info-icon">
                          <img src="../assets/icons/default/info_icon2.svg" />
                        </div>
                        <div class="auth-el-wrapper">
                          <div class="auth-el-title">
                            <p>IP Address: </p>
                          </div>

                          <div class="auth-el-icon">
                            <div class="icon icon__ip"></div>
                            <p>{{ auth.ip_address }}</p>
                          </div>
                        </div>

                        <div class="auth-el-wrapper">
                          <div class="auth-el-title">
                            <p>User Agent: </p>
                          </div>

                          <div class="auth-el-icon">
                            <div class="icon icon__browser"></div>
                            <p>{{ auth.user_agent }}</p>
                          </div>
                        </div>

                        <div class="auth-el-wrapper auth-el-wrapper-date">
                          <div class="auth-el-title">
                            <p>Login At: </p>
                          </div>

                          <div class="auth-el-icon">
                            <div class="icon icon__date"></div>
                            <p>{{ formatDate(auth.login_at) }}</p>
                          </div>

                          <div class="auth-el-icon">
                            <div class="icon icon__time"></div>
                            <p>{{ formatTime(auth.login_at) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Pagination :limit="3" :data="userAuthLog" @pagination-change-page="getResults">
                    </Pagination>
                  </template>
                </template>
              </div>
            </transition>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "@/partials/NoData";
import { mapGetters } from "vuex";
import moment from "moment";
import PolicyTable from "@/components/AccountDetails/PolicyTable";

import PendenciesTable from "@/components/AccountDetails/PendenciesTable";
import NotesTable from "@/components/AccountDetails/NotesTable";
import CallsTable from "@/components/AccountDetails/CallsTable";
import MandatesTable from "@/components/AccountDetails/MandatesTable";
import OffersTable from "@/components/AccountDetails/OffersTable";

import CustomerLeadsTable from "@/components/AccountDetails/CustomerLeadsTable";


import PotentialPolicyTable from "@/components/AccountDetails/PotentialPolicyTable";
import Accidents from "@/components/AccountDetails/Accidents";
import Loading from "@/partials/Loading";
import {
  parseBirthday,
  parseCustomerMemberName,
  parseMemberGender,
  parseInitials,
} from "@/helpers/entityParsers";
import statics from "@/statics";
import Notification from "@/components/Notification";
import Invoices from "@/components/AccountDetails/Invoices";
import MembersActionDropdown from "@/components/MembersActionDropdown";

import api from "@/api";

import SearchFilter from "@/partials/SearchFilter";
import _ from "lodash";
export default {
  name: "AccountDetails",

  components: {
    MembersActionDropdown,
    PolicyTable,
    CustomerLeadsTable,
    PendenciesTable,
    NotesTable,
    CallsTable,
    MandatesTable,
    OffersTable,

    PotentialPolicyTable,
    Accidents,
    Loading,
    Notification,
    Invoices,

    SearchFilter,

    NoData
  },

  watch: {
    '$route.query.tab': {
      handler(newTab) {
        if (newTab !== undefined) {
          this.activeTab = parseInt(newTab);
        } else if (this.$route.params.tab) {
          this.activeTab = parseInt(this.$route.params.tab);
        }
      },
      immediate: true
    },

    '$route.params.id': function (newId, oldId) {
      // Only trigger fetch when navigating between different IDs (not on initial load/refresh)
      if (newId && oldId && newId !== oldId) {
        // Update customerDetailsId in store when navigating to a different customer
        this.$store.commit("setCustomerDetailsId", newId);
        this.debouncedFetchEntity();
      }
    },

    '$route.params.subEntityType': {
      handler(newType) {
        const tabMap = {
          policy: 0,
          pendency: 1,
          note: 2,
          mandate: 3,
          call: 4,
          'potential-policy': 5
        };

        if (newType && tabMap[newType] !== undefined) {
          this.activeTab = tabMap[newType];
        }
      },
      immediate: false
    }
  },

  data() {
    return {

      showTeamDropdown: false,

      activeTab: this.getInitialTab(),
      showActionsDropdown: null,
      detailsLoading: true,
      showDetails: false,
      statics,
      parseCustomerMemberName,
      parseMemberGender,
      parseInitials,
      members: [],

      searchKeywordsUsers: "",
      searchKeywords: "",
      showSearchFilter: false,
      selectedAgents: [],
      selectedCompanyTypes: [],
      selectedCompanies: [],
      selectedBranchCategories: [],
      selectedPolicyStatuses: [],
      searchPlaceholder: "",
      hasTerminations: '',
      startDateFrom: "",
      startDateTo: "",
      endDateFrom: "",
      endDateTo: "",
      submitDateFrom: "",
      submitDateTo: "",
      paymentStatus: '',
      searchZip: "",
      searchBirthday: "",

      userAuthLog: {},
      logsLoading: false,
      debouncedFetchEntity: null,
      lastFetchedId: null, // Track the last fetched entity ID
      isFetching: false, // Prevent concurrent fetches
    };
  },

  async created() {
    this.debouncedFetchEntity = _.debounce(this.fetchEntity, 300);
    this.debouncedFetchEntity();

    // Remove this duplicate commit - fetchEntity() already sets customerDetailsId
    // await this.$store.commit("setCustomerDetailsId", this.$route.params.id);

    if (this.loggedUser.teams.length == 1) {
      await this.$store.dispatch("getSearchCustomerForms", this.loggedUser.teams[0].id);
    }
  },
  mounted() {
    if (this.$route.params.entity === 'lead') {
      const handleSubStatus = (cust) => {
        if (!cust) return false;

        const routeId = Number(this.$route.params.id);
        if (cust.id !== routeId) return false;

        const subId = cust.customer_sub_status?.id || cust.customer_sub_status_id;

        if (Number(subId) === 4 && cust.id) {
          this.$router.replace({
            path: `/account-details/customer/${cust.id}`,
            query: { tab: 5 }
          });
          this.$store.commit('setShowAddCustomerServicesModal', true)
        }

        return subId != null;
      };

      if (!handleSubStatus(this.customer)) {
        const unwatch = this.$watch('customer', (newVal) => {
          if (handleSubStatus(newVal)) {
            unwatch();
          }
        });
      }
    }
  },

  beforeDestroy() {
    // Cancel any pending debounced calls
    if (this.debouncedFetchEntity && this.debouncedFetchEntity.cancel) {
      this.debouncedFetchEntity.cancel();
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {

      if (to.query.tab !== undefined) {
        vm.activeTab = parseInt(to.query.tab);
        return;
      }

      const tabMap = {
        policy: 0,
        pendency: 1,
        note: 2,
        mandate: 3,
        call: 4,
        "potential-policy": 5
      };

      if (to.params.subEntityType && tabMap[to.params.subEntityType] !== undefined) {
        vm.activeTab = tabMap[to.params.subEntityType];
      }
    });
  },

  computed: {
    ...mapGetters(["customer", "customerMembers", "user", 'loggedUser']),

    photo() {
      if (
        (this.$route.params.entity === "customer" ||
          this.$route.params.entity === "potential-customer") &&
        this.customer && this.customer.photo
      ) {
        return this.customer.photo.preview;
      } else if (this.$route.params.entity === "user" && this.user && this.user.photo) {
        return this.user.photo.preview;
      }
      return null;
    },

    teamName() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer"
      ) {
        return this.customer && this.customer.team ? this.customer.team.name : null;
      }
      return null;
    },

    memberType() {
      return this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
        ? this.customer && this.customer.member_type ? this.customer.member_type.id : null
        : null;
    },

    birthday() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.birthday
          ? `${moment(this.customer.birthday).format("DD.MM.YYYY")} (${parseBirthday(this.customer.birthday)} years old)`
          : "";
      }
      return this.user && this.user.birthday
        ? `${moment(this.user.birthday).format("DD.MM.YYYY")} (${parseBirthday(this.user.birthday)} years old)`
        : "";
    },

    email() {
      if (this.$route.params.entity === "customer" || this.$route.params.entity === "potential-customer" || this.$route.params.entity === "lead") {
        return this.customer && Array.isArray(this.customer.customer_emails) && this.customer.customer_emails.length
          ? this.customer.customer_emails
          : [];
      }
      return this.user && this.user.email || "-";
    },

    phone() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.customer_phones) && this.customer.customer_phones.length
          ? this.customer.customer_phones
          : [];
      }
      return this.user && this.user.phone || "-";
    },

    street() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.customer_addresses) && this.customer.customer_addresses.length
          ? this.customer.customer_addresses[0].street
          : "-";
      }
      return this.user && Array.isArray(this.user.user_addresses) && this.user.user_addresses.length
        ? this.user.user_addresses[0].street
        : "-";
    },

    comment() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.comment || "-";
      }
      return this.user && this.user.comment || "-";
    },


    number() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.customer_addresses) && this.customer.customer_addresses.length
          ? this.customer.customer_addresses[0].number
          : "-";
      }
      return this.user && Array.isArray(this.user.user_addresses) && this.user.user_addresses.length
        ? this.user.user_addresses[0].number
        : "-";
    },

    zip() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.customer_addresses) && this.customer.customer_addresses.length
          ? this.customer.customer_addresses[0].zip
          : "-";
      }
      return this.user && Array.isArray(this.user.user_addresses) && this.user.user_addresses.length
        ? this.user.user_addresses[0].zip
        : "-";
    },

    city() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.customer_addresses) && this.customer.customer_addresses.length
          ? this.customer.customer_addresses[0].city
          : "-";
      }
      return this.user && Array.isArray(this.user.user_addresses) && this.user.user_addresses.length
        ? this.user.user_addresses[0].city
        : "-";
    },

    language() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.language ? this.customer.language.name : "-";
      }
      return this.user && this.user.language ? this.user.language.name : "-";
    },

    job() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.occupation || "-";
      }
      return this.user && this.user.occupation || "-";
    },

    employer() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.employer || "-";
      }
      return this.user && this.user.employer || "-";
    },

    ahvNr() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.ahv_number || "-";
      }
      return this.user && this.user.ahv_number || "-";
    },

    iBan() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.banks) && this.customer.banks.length
          ? this.customer.banks[0].account
          : "-";
      }
      return this.user && Array.isArray(this.user.user_banks) && this.user.user_banks.length
        ? this.user.user_banks[0].account || "-"
        : "-";
    },

    bankName() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && Array.isArray(this.customer.banks) && this.customer.banks.length
          ? this.customer.banks[0].name
          : "-";
      }
      return this.user && Array.isArray(this.user.user_banks) && this.user.user_banks.length
        ? this.user.user_banks[0].name || "-"
        : "-";
    },

    finmaNr() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.finma_nr || "-";
      }
      return this.user && this.user.finma_nr || "-";
    },

    country() {
      if (
        this.$route.params.entity === "customer" ||
        this.$route.params.entity === "potential-customer" ||
        this.$route.params.entity === "lead"
      ) {
        return this.customer && this.customer.country ? this.customer.country.name_en : "-";
      }
      return this.user && this.user.country ? this.user.country.name_en : "-";
    },

    sachbearbeiter() {
      if (this.$route.params.entity === "customer" || this.$route.params.entity === "potential-customer" || this.$route.params.entity === "lead") {
        if (this.customer && this.customer.owner) {
          return this.customer.owner.company_name || `${this.customer.owner.first_name} ${this.customer.owner.last_name}`;
        }
        return "-";
      }
      return "-";
    },

    policies() {
      if (this.$route.params.entity === "customer" || this.$route.params.entity === "potential-customer" || this.$route.params.entity === "lead") {
        return this.customer && this.customer.policies
          ? this.customer.policies.filter((police) => Array.isArray(police.policy_services) && police.policy_services.length)
          : [];
      }
      return null;
    },

    potentialPolicies() {
      if (this.$route.params.entity === "customer" || this.$route.params.entity === "potential-customer" || this.$route.params.entity === "lead") {
        return this.customer && this.customer.potential_policies || [];
      }
      return [];
    },

    terminations() {
      if (this.$route.params.entity === "customer" || this.$route.params.entity === "potential-customer" || this.$route.params.entity === "lead") {
        return this.customer && this.customer.terminations || [];
      }
      return null;
    },

    notifications() {
      if (this.$route.params.entity === "user" && this.user) {
        return this.user.notifications || [];
      }
      return null;
    },

    teams() {
      if (this.$route.params.entity === "user" && this.user && Array.isArray(this.user.teams)) {
        return this.user.teams;
      }
      return [];
    }
  },

  methods: {
    async getUserAuthLog(userId, page = 1) {
      this.logsLoading = true;
      try {
        const response = await api({ requiresAuth: true }).get(`/v1/users/${userId}/authentications?page=${page}`);
        this.userAuthLog = response.data;
        this.logsLoading = false;
      } catch (error) {
        console.error("Error fetching user authentications:", error);
        this.logsLoading = false;
        throw error;
      }
    },


    async getResults(paginationPage) {
      let page = Number(this.$route.query.page);

      if (Number(paginationPage) !== page) {
        this.$router.replace({
          query: { page: paginationPage },
        });

        page = Number(paginationPage);
      }

      await this.getUserAuthLog(this.$route.params.id, page);
    },

    async keywordsSearch() {
      this.$router.push({
        path: "/customers",
        query: {
          page: 1,
          search: this.searchKeywords || undefined,
          agents: this.selectedAgents || undefined,
          companyTypes: this.selectedCompanyTypes || undefined,
          companies: this.selectedCompanies || undefined,
          branchCategories: this.selectedBranchCategories || undefined,
          policyStatuses: this.selectedPolicyStatuses || undefined,
          birthday: this.searchBirthday || undefined,
          zip: this.searchZip || undefined,
          has_terminations: this.hasTerminations || undefined,
          startDateFrom: this.startDateFrom || undefined,
          startDateTo: this.startDateTo || undefined,
          endDateFrom: this.endDateFrom || undefined,
          endDateTo: this.endDateTo || undefined,
          submitDateFrom: this.submitDateFrom || undefined,
          submitDateTo: this.submitDateTo || undefined,
          payment_status: this.paymentStatus || undefined,
        },
      });
    },


    getInitialTab() {
      if (this.$route.query.tab !== undefined) {
        return parseInt(this.$route.query.tab);
      }

      const tabMap = { pendency: 1, policy: 0 };
      if (this.$route.params.subEntityType && tabMap[this.$route.params.subEntityType] !== undefined) {
        return tabMap[this.$route.params.subEntityType];
      }

      return this.$route.params.entity === "potential-customer" ? 5 : 0;
    },

    async fetchEntity() {
      const { id, entity } = this.$route.params;

      // Prevent fetching if already fetching or if we just fetched this ID
      if (this.isFetching) {
        console.log("Already fetching, skipping duplicate request");
        return;
      }

      // Check if we already have this entity loaded
      if (
        (entity === "customer" || entity === "potential-customer" || entity === "lead") &&
        this.customer &&
        this.customer.id == id &&
        this.lastFetchedId === `${entity}-${id}`
      ) {
        console.log("Entity already loaded, skipping fetch");
        this.detailsLoading = false;
        return;
      }

      if (entity === "user" && this.user && this.user.id == id && this.lastFetchedId === `${entity}-${id}`) {
        console.log("User already loaded, skipping fetch");
        this.detailsLoading = false;
        return;
      }

      this.isFetching = true;
      this.detailsLoading = true;

      try {
        if (entity === "customer" || entity === "potential-customer" || entity === "lead") {
          // Clear customer members only if switching to a different customer
          if (this.lastFetchedId !== `${entity}-${id}`) {
            this.$store.commit("setCustomerMembers", []);
            
            // Clear all child component data when switching customers
            this.$store.commit("setPendencies", []);
            this.$store.commit("setCalls", []);
            this.$store.commit("setNotes", []);
            this.$store.commit("setMandates", []);
            this.$store.commit("setOffers", []);
          }
          
          // Update the customer details ID in store before fetching
          this.$store.commit("setCustomerDetailsId", id);
          
          await this.$store.dispatch("getGlobalCustomer", id);
          
          // Set customerDetails for modals that depend on it (like AddPolicyModal)
          // Access directly from store to avoid computed property timing issues
          const customerData = this.$store.getters.customer;
          if (customerData) {
            this.$store.commit("setCustomerDetails", customerData);
          }
          
          this.lastFetchedId = `${entity}-${id}`;
        } else if (entity === "user") {
          const user = await this.$store.dispatch("getUser", id);
          this.$store.commit("setUser", user);
          this.lastFetchedId = `${entity}-${id}`;
        } else {
          this.$router.push({ name: "Dashboard" });
        }
      } catch (err) {
        console.error("Error in fetchEntity:", err);
      } finally {
        this.detailsLoading = false;
        this.isFetching = false;
      }
    },

    editEmail(customerId = null, emailId) {
      if (customerId == null)
        customerId = this.$route.params.id;
      if (this.memberType === 1) {
        this.$store.commit("setCompanyToEdit", customerId);
        this.$store.commit("setCompanyIsEdit", true);
        this.$store.commit("setEmailIdToEdit", emailId);
        this.$store.commit("setShowEditCompanyEmailModal", true);
      } else if (this.memberType === 2) {
        this.$store.commit("setPrivateToEdit", customerId);
        this.$store.commit("setPrivateIsEdit", true);
        this.$store.commit("setEmailIdToEdit", emailId);
        this.$store.commit("setshowEditPrivateEmailModal", true);
      }
    },

    editCustomer(customerId = null) {
      if (customerId == null)
        customerId = this.$route.params.id;
      if (this.memberType === 1) {
        this.$store.commit("setCompanyToEdit", customerId);
        this.$store.commit("setCompanyIsEdit", true);
        this.$store.commit("setShowAddCompanyModal", true);
      } else if (this.memberType === 2) {
        this.$store.commit("setPrivateToEdit", customerId);
        this.$store.commit("setPrivateIsEdit", true);
        this.$store.commit("setShowAddPrivateModal", true);
      }
    },

    editLead(leadCustomer = null) {
      if (!leadCustomer) leadCustomer = this.customer;
      this.$store.commit("setLeadCustomerToEdit", leadCustomer);
      this.$store.commit("setShowCustomerLeadModal", true);
    },

    editUser() {
      if (this.$route.params.entity === 'profile') {
        return;
      } else {
        this.$store.commit("setUserToEdit", this.$route.params.id);
        this.$store.commit("setIsEdit", true);
        this.$store.commit("setShowAddUserModal", true);
      }

    },

    editProfile() {
      this.$router.push({
        name: "Dashboard",
      });
    },

    detailsHeight() {
      if (!this.$refs.details) {
        return 0;
      }

      return [...this.$refs.details.children].reduce((acc, child) => {
        const { marginTop, marginBottom } = window.getComputedStyle(child);
        return (acc +=
          child.clientHeight + parseInt(marginTop) + parseInt(marginBottom));
      }, 0);
    },

    openAddMemberModal() {
      this.$store.commit("setCustomerToAddMember", this.$route.params.id);
      this.$store.commit("setShowAddFamilyMemberModal", true);
    },
 

    async deleteMember(memberId) {
      await this.$store.dispatch("deleteCustomer", memberId);
      this.lastFetchedId = null; // Reset to allow re-fetch
      await this.fetchEntity();
    },

    async separateMember(memberId) {
      await this.$store.dispatch("separateMember", memberId);
      this.lastFetchedId = null;  
      await this.fetchEntity();
    },  

    selectMember(memberId) { 
      this.lastFetchedId = null;
      
      this.$router.push({
        path: `/account-details/customer/${memberId}`,
        query: { tab: 0 }
      });
    },

    openTeamTaxes(team) {
      this.$store.commit("setUserToEdit", this.$route.params.id);
      this.$store.commit("setIsEdit", true);
      this.$store.commit('setShowTaxesModal', true);
      this.$store.commit('setTeamTaxesToEdit', team)
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    formatTime(dateString) {
      const date = new Date(dateString);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${hours}:${minutes}`;
    },


    //search users 
    async searchUsersForms() {
      this.$router.replace({
        path: "/users",
        query: {
          page: 1,
          search: this.searchKeywordsUsers
        },
      });
    },

    changeTab(tabIndex) {
      this.activeTab = tabIndex;
      this.$router.replace({
        query: { ...this.$route.query, tab: tabIndex }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.auth-el-title {
  width: 90px;
}

.auth-el-wrapper,
.auth-el-icon {
  display: flex;
  align-items: center;

  p {
    line-height: initial !important;
    margin: 0 !important;
    color: var(--text-2) !important;
    font-weight: bold !important;
  }
}

.auth-el-wrapper {
  gap: 10px;
  margin-bottom: 10px;
}

.auth-el-wrapper-date {
  margin-bottom: 0;
}

.auth-el-icon {
  gap: 5px;
  box-shadow: 0px 2px 4px var(--shadow-1);
  border-radius: var(--radius-1);
  background-color: white;
  padding: 5px 10px;
  padding-left: 7px;
  border-radius: 10px;
}

[data-theme="dark"] {
  .auth-el-icon {

    background-color: #313B47;
  }
}


.details {
  overflow: hidden !important;
}

.logs {
  padding: 40px 20px;
  height: 100%;
  overflow: auto;
}

.auth-row {
  padding: 30px 20px;
  background: var(--bg-16);
  border-radius: var(--radius-1);
  position: relative;
  margin-bottom: 30px;

  p {
    color: var(--text-9);
    line-height: 18px;
    font-size: var(--x-small);
    margin-bottom: 10px;

    b {
      margin-right: 10px;
    }

    :last-child {
      margin-bottom: 0;
    }
  }


  .info-icon {
    width: 60px;
    height: 34px;
    position: absolute;
    top: -22px;
    left: 0px;

    border-radius: 50%;

    img {
      width: 100%;
    }

  }
}


.user-team:hover {
  .member__icon {
    span {
      filter: brightness(0) invert(1);
    }

  }

  // .icon__dots{
  //   filter: brightness(0) invert(1);
  // }
}



.search-filter {
  z-index: 10;
}

.email__edit__icon {
  scale: 0.8;
  margin-top: -6px;
}

.icon__tick__color {
  background: url(../assets/icons/default/tick_icon_color.svg) no-repeat center;
}


.details {

  &__content,
  .detail__avatar,
  .det__header,
  .container .tabs,
  .detail__avatar-company-icon {
    display: flex;
  }

  &__avatar,
  .det__header,
  .detail__avatar-company-icon {
    align-items: center;
  }

  &__avatar,
  .detail__avatar-company-icon {
    justify-content: center;
  }
}




.details {
  height: 100%;

  &__content {
    height: calc(100% - 48px - 15px);
  }

  .detail {
    width: 250px;
    margin-right: 20px;
    background: var(--bg-1);
    border-radius: var(--radius-3);
    position: relative;
    overflow: auto;

    &__info {
      padding: 0 10px;
    }

    &__splitter {
      width: 100%;
      height: 2px;
      background: var(--bg-3);
    }

    &__edit {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    &__avatar {
      width: 115px;
      height: 115px;
      border-radius: 50%;
      border: 4px solid var(--border-2);
      margin: 30px auto;
      overflow: hidden;

      img {
        width: initial;
      }

      &-company-icon {
        background: var(--bg-4);
        width: 100%;

        img {
          width: 70%;
        }
      }
    }

    &__profile {
      margin: 15px 0;
      color: var(--text-9);
    }

    &__name {
      font-size: var(--large);
    }

    &__email__edit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }




    &__email,
    &__phone {
      font-size: var(--x-small);
      margin: 5px 0;
      transition: all 0.3s ease;

      &--secondary {
        color: var(--text-2);
        overflow: hidden;
      }
    }

    &__emails {
      margin: 10px 0;
    }

    .det {
      margin: 5px 0;
      cursor: pointer;

      &__header {
        justify-content: space-between;
      }

      &__chevron {
        height: 20px;
        width: 20px;
        background: url("../assets/icons/default/Bold 2px-chevron_down.svg");

        &--more {
          transform: rotate(180deg);
        }
      }

      &__title {
        color: var(--text-2);
        font-size: var(--x-smaller);
      }
    }

    &__label {
      font-size: var(--x-smaller);
      color: var(--text-2);
      margin: 10px 0;
    }

    &__detail {
      color: var(--text-9);
      font-size: var(--x-small);
      margin: 10px 0;
    }

    &__about {
      transition: all 0.3s ease;
      overflow: hidden;
    }

    .member {
      color: var(--text-5);
      background: var(--bg-6);
      margin: 20px 0;
      padding: 15px 0;
      text-align: center;
      position: relative;
      cursor: pointer;

      &__overlay,
      &__name {
        transition: all 0.2s ease-in-out;
      }

      &__overlay {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2px;
        background: var(--bg-2);
        z-index: 0;
      }

      &__name {
        font-family: var(--muli-text-semi-bold);
        font-size: var(--medium);
        position: relative;
        z-index: 1;
        padding: 0 35px 0 15px;
        word-break: break-all;
      }

      &--male {
        .member__icon {
          background: url("../assets/icons/default/male_user_icon.svg");
        }
      }

      &--female {
        .member__icon {
          background: url("../assets/icons/default/female_user_icon.svg");
        }
      }

      &:hover,
      &--active {
        .member__overlay {
          width: 100%;
        }

        .member__name {
          color: var(--text-1)
        }
      }

      .member__name {
        p {
          word-break: break-word;
          width: 90%;
          margin: 0 auto;
        }
      }
    }

    &__members {
      margin-top: 40px;

      .button {
        position: relative;

        &__icon {
          background: url("../assets/icons/default/Bold 2px-add.svg");
        }
      }
    }

    .button__icon,
    // .member__icon,
    .icon__delete,
    .icon__dots {
      height: 24px;
      width: 24px;
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .button__icon {
      left: 5px;
    }

    .button__text {
      width: 85%;
      margin-left: auto;
    }

    .icon__delete {
      right: 10px;
      left: initial;
      z-index: 1;
    }

    .icon__dots {

      right: 10px;
      left: initial;
      z-index: 1;

    }

    &__members .button,
    &__password-button {
      width: 180px;
      margin: auto;
    }

    &__password-button {
      margin-top: 60px;
    }
  }

  .member__icon {
    left: 8px;
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .container {
    width: calc(100% - 250px - 20px);

    .tabs {
      padding-left: 7px;

      .tab {
        color: var(--text-2);
        font-size: var(--medium);
        background: var(--bg-7);
        padding: 12px 25px 18px 25px;
        border-top-right-radius: var(--radius-1);
        border-top-left-radius: var(--radius-1);
        box-shadow: 0px 3px 6px var(--shadow-3);
        position: relative;
        cursor: pointer;

        &__badge {
          position: absolute;
          height: 16px;
          width: 16px;
          top: -6px;
          right: 8px;
          background: var(--bg-8);
          border-radius: 50%;
          color: var(--text-1);
          font-size: 10px;
          text-align: center;
          line-height: 15px;
        }

        // &:not(.tab--policy) {
        //   left: -4px;
        // }

        &--payments {
          z-index: 6;
        }

        &--policy {
          z-index: 5;
        }

        &--accidents {
          z-index: 4;
        }

        &--return {
          z-index: 3;
        }

        &--payments {
          z-index: 2;
        }

        &--activities {
          z-index: 1;
        }

        &--active {
          background: var(--bg-1);
          z-index: 6;
        }
      }
    }

    .content {
      position: relative;
      border-radius: var(--radius-3);
      background: var(--bg-1);
      box-shadow: 0px 2px 4px var(--shadow-1);
      top: -3px;
      z-index: 6;
      height: calc(100% - 48px);

      &__top {
        position: relative;
        z-index: 1;
      }

      ::v-deep .policies,
      ::v-deep .accidents,
      ::v-deep .payments,
      ::v-deep .mandates {
        height: 100%;
        background: inherit;
        border-radius: inherit;

        .table {
          &--inner {
            .table__body {
              padding-top: 0;
            }
          }

          &__header {
            box-shadow: 0px 5px 10px var(--shadow-1);
            margin-bottom: 0px;
            z-index: 2;
            position: relative;

            &--inner {
              box-shadow: inset 0px 3px 6px var(--shadow-3) !important;
              background: var(--bg-22);
              border-radius: 0;
              border-bottom: 1px solid var(--border-12);

              .table__label {
                border: 0;
                color: var(--text-13);

                &:first-of-type {
                  padding-left: 0 !important;
                }
              }
            }
          }

          &__label {
            &:first-of-type {
              padding-left: 20px;
            }
          }

          &__body {
            padding-top: 15px;
            height: calc(100% - 36px);
          }

          &__no-data {
            height: 100%;
          }

          &__policies {
            position: relative;
            z-index: 2;
          }
        }

        .policy-wrapper {

          &__accidents,
          &__payments {
            transition: all 0.3s ease;
            overflow: hidden;
          }

          .table__label {
            border: 0;
            text-align: left;
            padding-left: 40px;

            &:first-child {
              padding-left: 55px !important;
            }
          }
        }
      }

      .notifications {
        padding: 40px 20px;
        height: 100%;
        overflow: auto;
      }

      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.2s;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
      }

      .fade-enter-active {
        z-index: 1;
      }

      .fade-leave-active {
        z-index: -1;
      }

      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }
    }
  }
}

.select-user-team {
  background-color: transparent !important;
  // border: 1px solid black;
  width: 88% !important;
}

.team_field {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: visible;
}

.team_about {
  overflow: visible !important;
}

.icon__team {
  width: 10%;
}

// .vs__actions::after{
//   z-index: 100;
// }</style>
